module.exports = __webpack_public_path__ + "img/b0a0d9bfd47643ef6593d899371eb3b4.png";